import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

/**
 * FIX: pujingyu
 * 将所有路由进行了按需引入，提升页面加载性能
 */
const routes: Array<RouteRecordRaw> = [
  //Pc路由
  {
    path: "/test",
    component: () => import("@/TestV.vue")
  },
  {
    path: "/home",
    component: () => import("@/views/Pc/HomeView.vue")
  },
  {
    path: "/about-us",
    component: () => import("@/views/Pc/AboutView.vue")
  },
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/price",
    component: () => import("@/views/Pc/PriceView.vue")
  },
  {
    path: '/funcSafety',
    component: () => import("@/views/Pc/FunSafetyView.vue"),
  },
  {
    path: '/customer_case/:pageId',
    component: () => import("@/views/Pc/CustomerCaseView.vue"),

  },
  {
    path: '/automotive_toolchain',
    component: () => import("@/views/Pc/AutomotiveToolchainView.vue"),
  },
  {
    path: '/information_security',
    component: () => import("@/views/Pc/InformationSecurityView.vue"),
  },
  {
    path: '/industrial_intelligent_manufactur',
    component: () => import("@/views/Pc/IndustrialIntelligentManufacturView.vue"),
  },
  {
    path: '/freetrial',
    component: () => import("@/views/Pc/FreeTrial.vue"),
  },
  {
    path: '/funPages/:pageId',
    component: () => import('@/views/Pc/funPages.vue'),
  },
  
  //移动端路由
  {
    path: "/mb_home",
    component: () => import("@/views/Mobile/MbHomeView.vue")
  },
  {
    path: "/mb_price",
    component: () => import("@/views/Mobile/MbPriceView.vue")
  },
  {
    path: "/mb_about",
    component: () => import("@/views/Mobile/MbAboutView.vue")
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(function (to, from, next) {
  const { pageId } = to.params;
  window.scroll(0, 0)
  if (to.path.startsWith('/customer_case') && (pageId === undefined || pageId === null)) {
    next('/');
  } else {
    next();
  }
})

export default router
